module.exports = __webpack_public_path__ + "img/visa-card.be544f05.png";